"use strict";

var _managerApi = require("@storybook/manager-api");
var _lodash = require("lodash");
var _react = _interopRequireDefault(require("react"));
var _StatusDot = _interopRequireDefault(require("./components/StatusDot"));
var _StatusTag = _interopRequireDefault(require("./components/StatusTag"));
var _constants = require("./constants");
var _defaults = require("./defaults");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
_managerApi.addons.register(_constants.ADDON_ID, function (api) {
  _managerApi.addons.add(_constants.ADDON_ID, {
    title: 'Status',
    type: _managerApi.types.TOOL,
    render: function render() {
      var parameters = (0, _managerApi.useParameter)(_constants.ADDON_PARAM_KEY, null);
      return /*#__PURE__*/_react["default"].createElement(_StatusTag["default"], {
        parameters: parameters
      });
    }
  });
  _managerApi.addons.setConfig({
    sidebar: {
      renderLabel: function renderLabel(item) {
        var name = item.name,
          isLeaf = item.isLeaf;
        try {
          var status = api.getParameters(item.id, _constants.ADDON_PARAM_KEY);

          // item can be a Root | Group | Story
          if (!isLeaf || !status || !(status !== null && status !== void 0 && status.type)) {
            return name;
          }
          var statusConfigMap = _objectSpread(_objectSpread({}, _defaults.defaultStatuses), status.statuses || {});
          var statusName = '';
          if (Array.isArray(status.type)) {
            var _status$type;
            var firstStatus = (_status$type = status.type) === null || _status$type === void 0 ? void 0 : _status$type[0];
            statusName = typeof firstStatus === 'string' ? firstStatus : firstStatus.name;
          } else {
            statusName = status.type;
          }
          var statusConfig = statusConfigMap[statusName];
          if (!statusConfig) {
            return name;
          }
          var background = statusConfig.background,
            description = statusConfig.description;
          return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, name, /*#__PURE__*/_react["default"].createElement(_StatusDot["default"], {
            type: statusName,
            background: background,
            title: "".concat((0, _lodash.startCase)(statusName), ": ").concat(description)
          }));
        } catch (error) {
          return name;
        }
      }
    }
  });
});